import { IUserSummary } from '../../types/global/helper';

export const types = {
    CREATE_AFFILIATE: 'CREATE_AFFILIATE',
    CREATE_AFFILIATE_SUCCESS: 'CREATE_AFFILIATE_SUCCESS',
    CREATE_AFFILIATE_FAILED: 'CREATE_AFFILIATE_FAILED',

    GET_AFFILIATES: 'GET_AFFILIATES',
    GET_AFFILIATES_SUCCESS: 'GET_AFFILIATES_SUCCESS',
    GET_AFFILIATES_FAILED: 'GET_AFFILIATES_FAILED',

    DELETE_AFFILIATE: 'DELETE_AFFILIATE',
    DELETE_AFFILIATE_SUCCESS: 'DELETE_AFFILIATE_SUCCESS',
    DELETE_AFFILIATE_FAILED: 'DELETE_AFFILIATE_FAILED',
};

export interface IAffiliateCode {
    _id: string;
    affiliate_code: string;
    user: IUserSummary;
    usage: number;
    expiration: string;
    percentage: number;
    created_by: IUserSummary;
    __v: number;
}

export interface ICreateAffiliatePayload {
    affiliate_code: string;
    username: string;
    expiration: string;
    percentage: number;
}

export interface IGetAffiliatesPayload {
    page?: number;
    limit?: number;
}

export interface IGetAffiliatesResponse {
    status: string;
    totalCount: number;
    pageSize: number;
    currentPage: number;
    totalPages: number;
    results: number;
    data: {
        data: IAffiliateCode[];
    };
}

export interface IAffiliateState {
    affiliates: IAffiliateCode[];
    totalCount: number;
    pageSize: number;
    currentPage: number;
    totalPages: number;
    loading: boolean;
    error: string | null;
    createLoading: boolean;
    deleteLoading: boolean;
}
